import React from 'react'
import type { JSX } from 'react'

import type { DrawerButtonIntent } from './drawer-button-intent'

export function DrawerFullWidthAnchorElementButton({
  children,
  intent,
  href,
  rel = 'noreferrer',
  target = '_blank',
  ...anchorHTMLAttributes
}: {
  readonly children: React.ReactNode
  readonly intent: DrawerButtonIntent
} & Omit<
  JSX.IntrinsicElements['a'],
  // Omitted because required:
  | 'href'
  // Omitted because not allowed:
  | 'className'
> &
  Required<Pick<JSX.IntrinsicElements['a'], 'href'>>) {
  return (
    <a
      className={`block w-full py-4 border-t border-acorns-ivory contrast-more:border-acorns-stone-light font-demibold text-body text-center focus:outline-none cursor-pointer ${
        intent === 'positive'
          ? 'text-acorns-green contrast-more:text-acorns-ada-dark-green'
          : intent === 'secondary'
            ? 'text-acorns-stone'
            : intent === 'destructive'
              ? 'text-error'
              : 'text-acorns-slate'
      }`}
      href={href}
      rel={rel}
      target={target}
      {...anchorHTMLAttributes}
    >
      {children}
    </a>
  )
}
